import React, { useState } from "react";
import styled from "styled-components";
import useSWR from "swr";
import { JsonLdTags } from "../components/JsonLd";
import ReviewList from "../components/ReviewList";
import logos from "../logos";

const DoubleAction = styled.span`
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 0.8em;
  display: grid;

  a {
    font-size: 1em;
  }
`;

const ActionButton = styled.a`
  margin-top: 1em;
  display: block;
  text-align: center;
  background-color: #555;
  padding: 0.5em;
  font-size: 1.2em;

  border: 1px solid white;
  border-radius: 0.2em;
  color: white;
  text-decoration: none !important;

  &:hover,
  &:visited {
    text-decoration: none !important;
  }
`;

const BottomButton = (props) => {
  if (props.writeDisable) {
    return (
      <ActionButton {...props} href={props.merchant.publicUrl}>
        Read More Reviews
      </ActionButton>
    );
  } else {
    if (props.merchant.numReviews <= 3 || props.lastPage) {
      return (
        <ActionButton {...props} href={props.merchant.surveyUrl}>
          Write a Review
        </ActionButton>
      );
    } else {
      return (
        <DoubleAction>
          <ActionButton {...props} onClick={() => props.nextPage()}>
            Read More Reviews
          </ActionButton>
          <ActionButton {...props} href={props.merchant.surveyUrl}>
            Write a Review
          </ActionButton>
        </DoubleAction>
      );
    }
  }
};

const getParameterByName = (name) => {
  var url = window.location.href;
  // eslint-disable-next-line
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

const Attribution = styled.p`
  margin-top: 8px;
  display: flex;
  text-align: right;
  justify-content: flex-end;
  font-size: 12px;

  img {
    height: 14px;
    margin-left: 3px;
    width: 35px;
  }
`;

const RecentReviews = ({ merchant: merchantId, writeDisable, num }) => {
  const getMerchantId = () => {
    return merchantId || getParameterByName("merchantId");
  };

  const [pageIndex, setPageIndex] = useState(1)
  const [lastPage, setLastPage] = useState(false)
  const fetcher = (...args) => fetch(...args).then((r) => r.json());
  const { data } = useSWR(
    `${process.env.REACT_APP_API_HOST}/api/public/v2/merchants/${getMerchantId()}.json?widget=thirdparty`,
    fetcher,
    {
      revalidateOnFocus: false,
    }
  );

  if (!data) {
    return null;
  }

  const { merchant } = data;
  const { partner, state } = merchant;

  if (state == "cancelled") {
    return null;
  }

  let reviewPages = [];
  for (let i = 0; i < pageIndex; i++) {
    reviewPages.push(
      <ReviewList
        key={`review-page-${i}`}
        page={i + 1}
        merchant={merchant}
        hidePlatform={false}
        truncateText={true}
        truncateAt={2}
        expandInline={true}
        limit={num}
        lastPage={(boolean) => setLastPage(boolean)}
      />
    );
  }

  return (
    <div>
      <div>
        <JsonLdTags merchant={merchant} />
        {reviewPages}
      </div>
      <BottomButton
        id="bottom-button"
        target="_blank"
        merchant={merchant}
        writeDisable={writeDisable}
        lastPage={lastPage}
        nextPage={() => setPageIndex(pageIndex +1) }/>
      <Attribution>
        Powered by <img src={logos[partner]} alt={partner} />
      </Attribution>
    </div>
  );
};

export default RecentReviews;



// WEBPACK FOOTER //
// ./src/containers/UniversalRecent.js